import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import * as api from "@/lib/api";
import { useAuth, applyOwnerScope } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AcceptInvite() {
  const { token } = useParams();
  const { user, setUser } = useAuth();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (user && !submitting) navigate("/", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setSubmitting(true);
    try {
      const data = await api.acceptInvite({ token, password });
      await applyOwnerScope(data.user);
      setUser(data.user);
      toast.success("¡Bienvenido! Te asignamos a la finca.");
      navigate("/animales", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invitación inválida");
      setSubmitting(false);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center px-4 bg-[hsl(var(--background))]">
      <div className="w-full max-w-md bg-card border border-border rounded-2xl p-7">
        <h1 className="font-heading text-2xl font-semibold mb-2">Aceptar invitación</h1>
        <p className="text-sm text-muted-foreground mb-5">Elevá una contraseña para sumarte como encargado.</p>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1">
            <Label>Nueva contraseña</Label>
            <Input data-testid="accept-invite-password" type="password" required minLength={6} value={password} onChange={(e)=>setPassword(e.target.value)} className="h-11" />
          </div>
          <Button data-testid="accept-invite-submit" type="submit" disabled={loading} className="w-full h-12 bg-emerald-700 hover:bg-emerald-800">
            {loading ? "Activando…" : "Activar cuenta"}
          </Button>
        </form>
        <div className="mt-5 text-center text-sm text-muted-foreground">
          ¿Tenés cuenta? <Link to="/login" className="text-emerald-700 font-medium">Iniciá sesión</Link>
        </div>
      </div>
    </div>
  );
}
